var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rmr-segmented-control',{staticClass:"nrd-display",attrs:{"value":_vm.displayMode,"items":_vm.items,"variant":_vm.variant},on:{"input":function($event){_vm.displayMode = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }